import { IconCurrencyDollar, IconCurrencyRupee, IconTrendingUp } from '@tabler/icons-react'

export const FinanceCardWrapper = ({ title, value, percent, icon, iconBg, children }) => {
    return (
        <div
            className={`p-3 d-flex flex-column gap-4  justify-content-between `}
            style={{ backgroundColor: "#fff", height: "12rem", width: "100%", boxShadow: "0px 4px 3px 0px rgba(126, 126, 126, 0.1)", borderRadius: "0.625rem", border: "1px solid #e3e3e3", }}
        >
            <div className='d-flex gap-2 justify-content-between align-items-start '>
                {/* icon */}
                <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                        background: iconBg,
                        width: "2rem",
                        height: "2rem",
                        borderRadius: "0.625rem",
                        boxShadow: "0 2px 8px rgba(122, 58, 94, 0.08)"
                    }}
                >
                    {icon}
                </div>

                <div className='d-flex flex-column align-items-end'>
                    <span className="text-dark fw-medium text-end  pt-1" style={{ fontSize: "14.5px" }}>
                        {title}
                    </span>

                    <span className="d-flex align-items-center mb-0 pb-0" style={{ fontWeight: 400, fontSize: '1.8em' }}>
                        <IconCurrencyRupee size={30} stroke={2} />
                        {value}
                    </span>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: "column", alignItems: 'start' }}>
                <span className={`fs-14 }`} style={{ fontWeight: 600, color: "#27ae60" }} >
                    {percent}
                    <IconTrendingUp size={14} stroke={2} />
                </span>
                <span style={{ fontWeight: 500, fontSize: "12px" }}>From Last Week</span>
            </div>
        </div >
    )
}
